import type { RouteViewFactory } from '@/router/router'
import { loadIsChildProfile } from '@/header/childProfileNavGate'

// Lazy so KidsModeRestricted + its i18n bundle stay off the first-paint chunk
// that routes.tsx sits on.
const loadKidsModeRestricted = () => import('@/kidsMode/KidsModeRestricted')

/**
 * Wraps a route factory so a confirmed child profile gets the KidsModeRestricted
 * page instead of the wrapped Podcasts/Audiobooks page. Fails open — a
 * non-child, signed-out, or unresolved profile renders the real page (see
 * {@link loadIsChildProfile}), so a direct URL is never blocked for a non-child.
 */
export function kidsModeGuarded<T extends Record<string, string>>(
    factory: RouteViewFactory<T>
): RouteViewFactory<T> {
    return async (params, path) => {
        if (await loadIsChildProfile()) {
            return (await loadKidsModeRestricted()).KidsModeRestricted()
        }
        return factory(params, path)
    }
}
